const useValidate = (form: any) => {
    const isPasswordValid = form?.password.length > 7
    const isFirstNameValid = form?.first_name?.length > 2
    const isLastNameValid = form?.last_name?.length > 2
    const isPhoneValid: RegExp = /^\d{9,}$/
    const isEmailValid: RegExp =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    const usernameRegex: RegExp =
        /^[A-Za-z\u0600-\u06FF]+(-[A-Za-z\u0600-\u06FF]+)*$/

    return {
        isPasswordValid,
        isPhoneValid,
        isEmailValid,
        isFirstNameValid,
        isLastNameValid,
        usernameRegex,
    }
}

export default useValidate
